import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, DadosBasicos } from './types';

export const INITIAL_STATE: DadosBasicos = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): DadosBasicos {
	return produce(state, draft => {
		switch (action.type) {
			case Types.DADOS_BASICOS_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.DADOS_BASICOS_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.DADOS_BASICOS_FAILURE: {
				draft.status = action.payload.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
